import { 
  Typography, 
  Box, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper 
} from '@mui/material';
import CodeBlock from '../../CodeBlock';

function TradeSubmission() {
  return (
    <Box sx={{ textAlign: 'left' }}>
      <Typography variant="body1" paragraph>
        The Trade Submission endpoint is used by traders to submit a DDS statement
        for trade operations. This specialized endpoint includes specific fields for
        associating with existing DDS statements.
      </Typography>
      
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>
        Endpoint
      </Typography>
      <CodeBlock code="POST /api/eudr/dds" />
      
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>
        Request Body
      </Typography>
      <CodeBlock 
        code={`{
  "operatorType": "TRADER",
  "statement": {
    "internalReferenceNumber": "FR-000004",
    "activityType": "TRADE",
    "countryOfActivity": "FR",
    "borderCrossCountry": "FR",
    "comment": "Some comments for the CA",
    "commodities": [{
      "descriptors": {
        "descriptionOfGoods": "here is the description of goods",
        "goodsMeasure": {
          "volume": 20,
          "netWeight": 40,
          "supplementaryUnit": 10,
          "supplementaryUnitQualifier": "MTQ"
        }
      },
      "hsHeading": "1806",
      "speciesInfo": {
        "scientificName": "Test",
        "commonName": "Test"
      }
    }],
    "geoLocationConfidential": false,
    "associatedStatements": [{
      "referenceNumber": "24FR9DXMIWUG91",
      "verificationNumber": "U8H1FW38"
    }]
  }
}`} 
      />

      <Typography variant="body1" paragraph sx={{ mt: 3 }}>
        <strong>Key Parameters Specific to Trade Submission:</strong>
      </Typography>
      
      <TableContainer component={Paper} sx={{ mt: 1, mb: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Parameter</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>operatorType</TableCell>
              <TableCell>"TRADER" specifies the operator is a trader</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>activityType</TableCell>
              <TableCell>"TRADE" specifies this is a trade operation</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>associatedStatements</TableCell>
              <TableCell>Array of references to existing DDS statements that this trade is based on</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>
        Response
      </Typography>
      <CodeBlock 
        code={`{
  "status": "success",
  "httpStatus": 201,
  "data": {
    "ddsIdentifier": "3f09ab3f-4c97-4663-8463-89d58f1d646b"
  }
}`} 
      />
      
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 2 }}>
        Response Codes
      </Typography>
      <TableContainer component={Paper} sx={{ mt: 1 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Code</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>201</TableCell>
              <TableCell>DDS statement successfully created</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>400</TableCell>
              <TableCell>Bad request - missing or invalid parameters</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>401</TableCell>
              <TableCell>Unauthorized - invalid credentials</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>404</TableCell>
              <TableCell>Referenced DDS statement not found</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>500</TableCell>
              <TableCell>Server error</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default TradeSubmission; 